import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { ProductFormService } from "../shared";

@Component({
  selector: "product-header-form",
  templateUrl: "./product-header-form.component.html",
  styleUrls: ["./product-header-form.component.scss"],
})
export class ProductHeaderFormComponent {
  @Input() form: FormGroup;

  types: Array<Object> = [];

  constructor(
    public ft: FormToolsService,
    public formService: ProductFormService
  ) {
    this.types = [
      { value: "image", label: "Imagen" },
      { value: "video", label: "Video" },
      { value: "special-effect", label: "Efecto Especial" },
    ];
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-header-form/product-header-form.component.ts